import {ModuleConfiguration} from "../router/model/UserPermission";
import {DragularModuleName, DynamicOrderingModuleName} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";


export const DynamicOrderingModuleConfig = new ModuleConfiguration(
    DynamicOrderingModuleName,
    [DragularModuleName, AngularJsMaterialModuleName]
);